import { render, staticRenderFns } from "./ConversationWorkflow.vue?vue&type=template&id=655e5434&scoped=true"
import script from "./ConversationWorkflow.vue?vue&type=script&lang=js"
export * from "./ConversationWorkflow.vue?vue&type=script&lang=js"
import style0 from "./ConversationWorkflow.vue?vue&type=style&index=0&id=655e5434&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655e5434",
  null
  
)

export default component.exports